import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'custom-bonus-radiobutton',
    template: `<h3 class="bonus-title-blk" *ngIf="to.label">{{to.label}}</h3>
    <div class="bonus-wrapper" *ngIf="to.myoptions">
      <div class="bonus_sub_blk" *ngFor="let option of to.myoptions; let i = index" (change)="onChange(option.value,i)">
      <div *ngIf="option.value=='NA'" style="margin:5px 4px 0 5px;"> 
        <input type="radio" name="{{'question'+to.question_id}}" id="{{option.value}}" class="bonus_radio_blk" 
          [ngClass]="{'checked': option.value == isSelected }" [checked]="option.value == isSelected " [disabled]="option.disabled">
          <label for="{{option.value}}"  class="option-na {{option.value}}">
              <span>{{option.label | translate}}  </span>
            </label>
            
          <div class="bonus-icon-na" *ngIf="option.value == isSelected">
          <img src="/assets/img/treasure_hunt/selected.svg"/>
          </div>
        </div>

        <div *ngIf="option.value!='NA'" style="margin:5px 4px 0 20px;"> 
        <input type="radio" name="{{'question'+to.question_id}}" id="{{option.value}}" class="bonus_radio_blk" 
          [ngClass]="{'checked': option.value == isSelected }" [checked]="option.value == isSelected " [disabled]="option.disabled">
          <label for="{{option.value}}"  class="option {{option.value}}">
              <span>{{option.label | translate}}</span>
            </label>
            
          <div *ngIf="option.value == isSelected" class="bonus-icon">
            <img src="/assets/img/treasure_hunt/selected.svg"/>
          </div>
        </div>
      </div>
    </div>
    `,
    standalone: false
})

export class BonusRadioButtonFormlyType extends FieldType {
  locationsType;
  isSelected: any;
  constructor() {
    super();
  }

  ngOnInit() {
    //this.isSelected = this.to.defaultset;

  }

  onChange(option: any, index) {

    this.formControl.patchValue(option);
    this.formControl.markAsTouched();
    this.isSelected = option;
  }

}